import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';

export default function Citizenship({ handleUpdate, client }) {
  return (
    <>
      <MetaControl
        attrName="citizenshipDetails"
        onChange={value => handleUpdate(client.attr('citizenshipDetails', value))
        }
        resource={client}
      />
      {/* Hard-coding this logic because it is a temporary fix until Blake makes some mods to facet-rest */}
      {client.attr('citizenshipDetails') && client.attr('citizenshipDetails') !== 'USA' && (
        <MetaControl
          attrName="residentType"
          onChange={value => handleUpdate(client.attr('residentType', value))
          }
          resource={client}
        />
      )}
    </>
  );
}

Citizenship.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};
